import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    marginBottom: 32,
  },
  image: {
    width: "100%",
    height: 350,
  },
  title: {
    fontFamily: "open-sans-bold",
    fontSize: 24,
    margin: 10,
    textAlign: "center",
    color: "white",
  },
  detailText: {
    color: "white",
  },
  listOuterContainer: {
    alignItems: "center",
  },
  listContiner: {
    width: "80%",
  },
});

export default styles;
